import { Navigate, Route, Routes } from 'react-router-dom';

import { RequireSession } from './components/RequireSession';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Reachable with or without a session, so an operator who has been locked
          out of everything else can still rotate. `RequireSession` redirects to
          this page when the flag is set; the page itself returns null without a
          session, which `RequireSession` turns into a redirect to /login. */}
      <Route
        path="/change-password"
        element={
          <RequireSession>
            <ChangePasswordPage />
          </RequireSession>
        }
      />
      <Route
        path="/"
        element={
          <RequireSession>
            <DashboardPage />
          </RequireSession>
        }
      />
      {/* Anything not matched above is genuinely absent; redirecting to the
          dashboard would hide a bad link from whoever reported it. */}
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
